import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import useUniqueId from 'hooks/useUniqueId';
import { Menu, MenuButton, MenuItem, MenuList } from 'components/Menu';
import HintTooltip from 'components/HintTooltip';
import Flex from 'components/Flex';
import AddAttendeesManager from './AddAttendeesManager';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
function AddAttendeesMenu(_ref) {
  var sessionId = _ref.sessionId,
    eventId = _ref.eventId,
    sessionCapacity = _ref.sessionCapacity,
    sessionAttendeesCount = _ref.sessionAttendeesCount,
    overallContentAudienceType = _ref.overallContentAudienceType;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var menuId = useUniqueId();
  var descriptionId = useUniqueId();
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    memberTypeToAdd = _useState2[0],
    setMemberTypeToAdd = _useState2[1];
  var isAdminContent = overallContentAudienceType === 'admin';
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Menu, {
      id: menuId,
      children: [/*#__PURE__*/_jsxs(Flex, {
        children: [/*#__PURE__*/_jsx(MenuButton, {
          icon: "plus",
          iconRight: "chevron",
          size: "medium",
          variant: "primary",
          isDisabled: isAdminContent,
          "aria-describedby": isAdminContent ? descriptionId : undefined,
          children: t('actions_add_members')
        }), isAdminContent && /*#__PURE__*/_jsx(HintTooltip, {
          content: t('hint_admin_content_cannot_add_session_attendees'),
          id: descriptionId,
          spacingLeft: "xxs"
        })]
      }), /*#__PURE__*/_jsxs(MenuList, {
        children: [/*#__PURE__*/_jsx(MenuItem, {
          icon: "user",
          onClick: function onClick() {
            return setMemberTypeToAdd('individual');
          },
          children: t('state_individual_members')
        }), /*#__PURE__*/_jsx(MenuItem, {
          icon: "team",
          onClick: function onClick() {
            return setMemberTypeToAdd('team');
          },
          children: t('state_team_members')
        })]
      })]
    }), memberTypeToAdd && /*#__PURE__*/_jsx(AddAttendeesManager, {
      sessionId: sessionId,
      sessionCapacity: sessionCapacity,
      sessionAttendeesCount: sessionAttendeesCount,
      eventId: eventId,
      memberTypeToAdd: memberTypeToAdd,
      onClose: function onClose() {
        return setMemberTypeToAdd(null);
      }
    })]
  });
}
export default AddAttendeesMenu;